import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { PremiumButton } from "../components/PremiumButton";
import { fadeIn, slideUp, staggerContainer } from "../animations";
import * as Icons from "lucide-react";
import { DevicePriceWizardV2 } from "../components/DevicePriceWizardV2";

export const C2BGeraetAnbieten = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Section */}
      <section className="relative min-h-[50vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-[#1f7db6] via-[#143e6e] to-[#1f7db6]" />
        
        <motion.div
          className="absolute top-20 -left-40 w-96 h-96 bg-white/10 rounded-full blur-3xl"
          animate={{ scale: [1, 1.2, 1], opacity: [0.3, 0.5, 0.3] }}
          transition={{ duration: 8, repeat: Infinity, ease: "easeInOut" }}
        />
        <motion.div
          className="absolute bottom-20 -right-40 w-96 h-96 bg-white/10 rounded-full blur-3xl"
          animate={{ scale: [1.2, 1, 1.2], opacity: [0.5, 0.3, 0.5] }}
          transition={{ duration: 8, repeat: Infinity, ease: "easeInOut", delay: 1 }}
        />

        <motion.div
          initial="hidden"
          animate="visible"
          variants={staggerContainer}
          className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8 text-center"
        >
          <motion.h1 variants={slideUp} className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6">
            Gerät anbieten
          </motion.h1>
          <motion.p variants={slideUp} className="text-xl sm:text-2xl text-white/90 mb-10 max-w-3xl mx-auto">
            Erhalten Sie Ihr Sofortangebot in wenigen Minuten
          </motion.p>
        </motion.div>
      </section>

      {/* Wizard Section */}
      <section className="py-20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={fadeIn}
            className="max-w-4xl mx-auto"
          >
            <DevicePriceWizardV2 />
          </motion.div>
        </div>
      </section>

      {/* Info Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true }}
            variants={staggerContainer}
            className="max-w-3xl mx-auto text-center"
          >
            <motion.h2 variants={slideUp} className="text-4xl font-bold text-[#143e6e] mb-8">
              So geht es weiter
            </motion.h2>
            <motion.div variants={slideUp} className="space-y-6 text-lg text-gray-700">
              <p>
                Nach Erhalt Ihres Angebots können Sie sich in Ruhe entscheiden. Wenn Sie das Angebot annehmen, senden Sie uns Ihr Gerät kostenlos zu.
              </p>
              <p>
                Wir prüfen Ihr Gerät und überweisen Ihnen den vereinbarten Betrag innerhalb von 1-2 Werktagen.
              </p>
              <p className="font-semibold">
                Einfach, schnell und fair - so sollte Verkaufen sein!
              </p>
            </motion.div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};
